/**
 * Which thread list belongs in the sidebar "Recent" slot for this route.
 * The three stores are separate; anything else hides Recent.
 */
export type SidebarRecentVariant = "workflow" | "policy" | "project" | "hidden";

/** `/u/projects/<id>/...` — the project detail routes, not the project list. */
const PROJECT_DETAIL_PATH = /^\/u\/projects\/([^/]+)/;

export function resolveSidebarRecentVariant(
  pathname: string,
): SidebarRecentVariant {
  if (pathname.startsWith("/u/policies")) return "policy";
  if (pathname.startsWith("/u/alpha/agent")) return "workflow";
  if (PROJECT_DETAIL_PATH.test(pathname)) return "project";
  return "hidden";
}

/** The sidebar sits above these routes, so `useParams` never sees `projectId`. */
export function resolveSidebarProjectId(pathname: string): string | null {
  return PROJECT_DETAIL_PATH.exec(pathname)?.[1] ?? null;
}
